
/* 全局方法对象 */
const common = {
  // API_PATH: 'http://192.168.0.111:10010/aosuite/notokenapi/app/v1',
  API_PATH: 'http://api.kfc.1688sup.cn/api/',
  // API_PATH: 'akwdhkasbd',

  pageInitInfo: JSON.parse(sessionStorage.getItem('pageInitInfo')) || {},
  /**
   * day 几天后 number
   * */

  // 页面类型码值的转换，后台未提供码值接口本地直接转换
  changeCode(key) {
    const data = [
      {
        text: '视频调解',
        val: 30000635,
        type: 'video'

      },
      {
        text: '还款账户',
        val: 30000640,
        type: 'repay'
      },
      {
        text: '证据资料',
        val: 30000634,
        type: 'convey'
      }
    ]
    for (const code of data) {
      if (code.val == key) {
        return code
      }
    }
  },
  getNowFormatDate: function(day) {
    var date = new Date()
    if (day && typeof day === 'number') date.setDate(date.getDate() + day)
    var seperator1 = '-'
    var year = date.getFullYear()
    var month = date.getMonth() + 1
    var strDate = date.getDate()
    if (month >= 1 && month <= 9) {
      month = '0' + month
    }
    if (strDate >= 0 && strDate <= 9) {
      strDate = '0' + strDate
    }
    return year + seperator1 + month + seperator1 + strDate
  },
  // url进行取值
  UrlToJson(name, url) {
    return url.slice(url.indexOf(name) + name.length + 1, url.indexOf('&', url.indexOf(name)) == -1 ? url.length : url.indexOf('&', url.indexOf(name)))
  },
  /*
  * 金额数据处理
  * 大于一万返回xx万，反之返回自身并保留2位小数
  * */
  amount_processing: function(amount) {
    if (Math.abs(amount) < 10000) {
      return amount.toFixed(2)
    } else {
      return (amount / 10000).toFixed(2) + '万'
    }
  },
  isJson: function($string) {
    try {
      if (typeof JSON.parse($string) === 'object') { return true }
      return false
    } catch (e) {
      return false
    }
  },
  // 判断字符是否为空的方法
  isEmpty: function(obj) {
    if (typeof obj === 'undefined' || obj == null || obj == '') {
      return true
    } else {
      return false
    }
  },
  /*
* 浮点数运算函数
* */
  // 加法
  float_add: function(arg1, arg2) {
    if (!(typeof (arg1) === 'number') && (arg1 !== Infinity) && !isNaN(arg1)) {
      return 0
    }
    if (!(typeof (arg2) === 'number') && (arg2 !== Infinity) && !isNaN(arg2)) {
      return 0
    }
    let r1, r2, m
    try { r1 = arg1.toString().split('.')[1].length } catch (e) { r1 = 0 }
    try { r2 = arg2.toString().split('.')[1].length } catch (e) { r2 = 0 }
    m = Math.pow(10, Math.max(r1, r2))
    return (arg1 * m + arg2 * m) / m
  },
  // 减法
  float_sub: function(arg1, arg2) {
    if (!(typeof (arg1) === 'number') && (arg1 !== Infinity) && !isNaN(arg1)) {
      return 0
    }
    if (!(typeof (arg2) === 'number') && (arg2 !== Infinity) && !isNaN(arg2)) {
      return 0
    }
    let r1, r2, m, n
    try { r1 = arg1.toString().split('.')[1].length } catch (e) { r1 = 0 }
    try { r2 = arg2.toString().split('.')[1].length } catch (e) { r2 = 0 }
    m = Math.pow(10, Math.max(r1, r2))
    n = (r1 >= r2) ? r1 : r2
    return ((arg1 * m - arg2 * m) / m).toFixed(n)
  },
  // 除法
  float_div: function(arg1, arg2) {
    if (!(typeof (arg1) === 'number') && (arg1 !== Infinity) && !isNaN(arg1)) {
      return 0
    }
    if (!(typeof (arg2) === 'number') && (arg2 !== Infinity) && !isNaN(arg2)) {
      return 0
    }
    let t1, t2, r1, r2
    try { t1 = arg1.toString().split('.')[1].length } catch (e) { t1 = 0 }
    try { t2 = arg2.toString().split('.')[1].length } catch (e) { t2 = 0 }
    r1 = Number(arg1) * Math.pow(10, Math.max(t1, t2))
    r2 = Number(arg2) * Math.pow(10, Math.max(t1, t2))
    return (r1 / r2)
  },
  // 乘法
  float_mul: function(arg1, arg2) {
    if (!(typeof (arg1) === 'number') && (arg1 !== Infinity) && !isNaN(arg1)) {
      return 0
    }
    if (!(typeof (arg2) === 'number') && (arg2 !== Infinity) && !isNaN(arg2)) {
      return 0
    }
    // eslint-disable-next-line one-var
    let m = 0, s1 = arg1.toString(), s2 = arg2.toString()
    try { m += s1.split('.')[1].length } catch (e) {}
    try { m += s2.split('.')[1].length } catch (e) {}
    return Number(s1.replace('.', '')) * Number(s2.replace('.', '')) / Math.pow(10, m)
  },
  // 通过js的内置对象JSON来进行数组对象的深拷贝
  Copy: function(obj) {
    const _obj = JSON.stringify(obj)
    return JSON.parse(_obj)
  },
  // 关闭当前弹出层
  modasear(res, Modals_where, name, refresh) {
    if (res.code === 1) {
      Modals_where[name] = false
      this.pageRefresh(refresh.pagingTable, refresh.startSearchData, refresh.searchData)
      this.instance('success', res)
    } else {
      this.instance('error', res)
    }
  },
  /* 刷新按钮 */
  refresh({ pagingTable, startSearchData, searchData }) {
    searchData.cat_id = ''
    /* 注意：不能将searchData引用为startSearchData，否则后续刷新将失效——引用（指针）与内存空间的问题 */
    const obj = {}
    Object.keys(startSearchData).forEach(key => {
      obj[key] = startSearchData[key]
    })
    for (const v in searchData) {
      searchData[v] = ''
    }
    pagingTable.refresh(searchData)
  },
  /* 保留page刷新table */
  pageRefresh(pagingTable, startSearchData, searchData) {
    const obj = {}
    Object.keys(startSearchData).forEach(key => {
      obj[key] = startSearchData[key]
    })
    searchData = obj
    pagingTable.pageRefresh(searchData)
  },
  /* 搜索按钮 */
  search({ pagingTable, searchData }) {
    pagingTable.search(searchData)
  },
  // 请求完成后进行提示
  instance(type, res) {
    const content = res.msg
    switch (type) {
      case 'info':
        Modal.info({
          title: '提示',
          content: content
        })
        setTimeout(() => {
          Modal.remove()
        }, 2500)
        break
      case 'success':
        Modal.success({
          title: '成功',
          content: content
        })
        setTimeout(() => {
          Modal.remove()
        }, 2500)
        break
      case 'warning':
        Modal.warning({
          title: '警告',
          content: content
        })
        setTimeout(() => {
          Modal.remove()
        }, 2500)
        break
      case 'error':
        Modal.error({
          title: '错误',
          content: content
        })
        setTimeout(() => {
          Modal.remove()
        }, 2500)
        break
    }
  },
  // 普通弹窗提示
  instance_Tips(type, msg, title) {
    switch (type) {
      case '0':
        Modal.info({
          title: '提示',
          content: msg
        })
        setTimeout(() => {
          Modal.remove()
        }, 2500)
        break
      case '1':
        Modal.success({
          title: '成功',
          content: msg
        })
        setTimeout(() => {
          Modal.remove()
        }, 2500)
        break
      case '2':
        Modal.warning({
          title: '警告',
          content: msg
        })
        setTimeout(() => {
          Modal.remove()
        }, 2500)
        break
      case '3':
        Modal.error({
          title: '错误',
          content: msg
        })
        setTimeout(() => {
          Modal.remove()
        }, 2500)
        break
    }
  },
  // 拉平数组
  flat(arr, name = children) {
    return [].concat(...arr.map(item => [].concat(item, ...this.flat(item[name]))))
  },
  SeeJudge(url) {
    const see_type = url.substring(url.lastIndexOf('.'), url.length)
    const see_type_list = {
      office: '.pptx.docx.excex.xlsx',
      pdf: '.pdf',
      img: '.gif.jpg..jpeg.png.gif.webp.wbm'
    }
    for (const see_type_list_value in see_type_list) {
      if (see_type_list[see_type_list_value].includes(see_type)) {
        return see_type_list_value
      }
    }
    return false
  }

}
export default common
